// Copyright (c) Ensho Health, 2021 to present
import api from '../api';
import { logout } from './auth.action.js';
import { setNotification, NOTIFICATION_TYPES } from './notification.action.js';

const PREFIX = 'heartbeat';
export const ACTION_TYPES = {
  ERROR: `${PREFIX}-ERROR`,
  LOADING: `${PREFIX}-LOADING`,
  HEARTBEAT_START: `${PREFIX}-HEARTBEAT_START`,
  HEARTBEAT_STOP: `${PREFIX}-HEARTBEAT_STOP`,
  UNREACHABLE_BACKEND: `${PREFIX}-UNREACHABLE_BACKEND`
};

/**
 * this the hertbeat interval call back.
 * CAREFUL. This is not a normal action strucutre. Here dispatch and getState
 * are *parameters* of the function.
 * The purpose of this function is mainly to make the startHeartbeat action
 * cleaner
 *  */
async function heartbeatInterval(dispatch, getState) {
  try {
    await api.heartbeat.sendHeartbeat();
  } catch (error) {
    // this error means that we can't reach our api
    if (error.message === 'LOGOUT') {
      const state = getState();
      if (
        state.heartbeat.unreachableBackendCount ===
        state.heartbeat.MAX_UNREACHABLE_BACKEND_COUNT
      ) {
        dispatch(stopHeartbeat());
        dispatch(logout());
      } else {
        dispatch({ type: ACTION_TYPES.UNREACHABLE_BACKEND });
      }
    } else {
      await setNotification({
        type: NOTIFICATION_TYPES.ERROR,
        serverMessage: error.message,
        info: { location: 'heartbeat.action.heartbeatInterval' }
      });
    }
  }
}

export function startHeartbeat() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      // making sure no listener is already running
      if (!state.heartbeat.heartbeatScheduler) {
        const heartbeat = setInterval(
          () => heartbeatInterval(dispatch, getState),
          state.heartbeat.HEARTBEAT_INTERVAL
        );
        dispatch({ type: ACTION_TYPES.HEARTBEAT_START, payload: heartbeat });
      }
    } catch (error) {
      console.error('heartbeat.action.startHeartbeat: ' + error.message);
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function stopHeartbeat() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      if (state.heartbeat.heartbeatScheduler) {
        clearInterval(state.heartbeat.heartbeatScheduler);
      }
      dispatch({ type: ACTION_TYPES.HEARTBEAT_STOP });
    } catch (error) {
      console.error('heartbeat.action.stopHeartbeat: ' + error.message);
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function pulse() {
  return async (dispatch) => {
    try {
      await api.heartbeat.sendHeartbeat();
    } catch (error) {
      console.error(error.message);
      await setNotification({
        type: NOTIFICATION_TYPES.ERROR,
        serverMessage: error.message,
        info: { location: 'heartbeat.action.pulse' }
      });
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}
